// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null);
  const [loadingRole, setLoadingRole] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setUserRole(null);
        localStorage.removeItem('userRole');
        setLoadingRole(false);
        return;
      }

      try {
        const tokenResult = await user.getIdTokenResult(true);
        let resolvedRole = tokenResult?.claims?.role || null;

        if (!resolvedRole) {
          const snap = await getDoc(doc(db, 'users', user.uid));
          resolvedRole = snap.exists() ? snap.data().role || null : null;
        }

        setUserRole(resolvedRole);
        if (resolvedRole) {
          localStorage.setItem('userRole', resolvedRole);
        } else {
          localStorage.removeItem('userRole');
        }
      } catch (err) {
        console.warn('No pudimos resolver el rol del usuario:', err);
        setUserRole(null);
        localStorage.removeItem('userRole');
      } finally {
        setLoadingRole(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const logout = () => {
    setUserRole(null);
    localStorage.removeItem('userRole');
    const auth = getAuth();
    signOut(auth).catch(() => {});
  };

  return (
    <AuthContext.Provider value={{ userRole, setUserRole, logout, loadingRole }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
